import React from "react";
import notFoundImg from "../../assets/notFoundRouting.svg";
import { Box } from "@mui/material";

interface PageNotFoundProps {
  message?: string;
  status?: string;
}

const PageNotFound = (props: PageNotFoundProps): React.ReactElement => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minHeight: "85vh",
          justifyContent: "center"
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <img src={notFoundImg} alt="" />
          <h1>{props.status ? props.status : 404}</h1>
          <p>Page Not Found</p>
          <p>{props.message ? props.message : "You seem redirect wrongly"}</p>
        </Box>
      </Box>
    </>
  );
};

export default PageNotFound;
